import type { DepreciationAsset, InternalCategory } from '@libs/enums';
import type { ItemAttributes, ItemNames, OrEmpty, WithExclusionObject } from '@ps-smart-cp/ppfw-client';
import { Characters, ItemName, Locale, SingleValue, WithExclusion } from '@ps-smart-cp/ppfw-client';

interface Schema {
  // 内部種類
  internalCategory: OrEmpty<InternalCategory>;

  // 償却資産区分
  depreciationAssetClass: OrEmpty<DepreciationAsset>;

  // 種類マスタコード
  categoryMstCode: string;

  // 種類名称
  categoryMstName: string;

  // 種類マスタコード(抽出条件)
  categoryMstCodeRange: WithExclusionObject;

  // 種類(表示用)
  category: string;

  // 種類名称
  categoryName: string;

  // 種類コード範囲(抽出条件)
  categoryCodeRange: WithExclusionObject;
}

const attributes = {
  internalCategory: SingleValue.shortValue(true),
  categoryMstCode: Characters.preset.halfWidth({ minLen: 2, maxLen: 2, required: true }),
  categoryMstCodeRange: WithExclusion.of(Characters.preset.halfWidth({ maxLen: 250 })),
  category: Characters.preset.halfWidth({ minLen: 2, maxLen: 2 }),
  categoryName: Characters.preset.freeFormat(),
  categoryCodeRange: WithExclusion.of(Characters.preset.halfWidth({ maxLen: 250 })),
} satisfies ItemAttributes<Omit<Schema, 'depreciationAssetClass'>>;

interface Record {
  internalCategory: string;
  depreciationAssetClass: string;
  categoryMstCode: string;
  categoryMstCodeRange: string;
  isCategoryMstCodeRangeExcluded: boolean;
  category: string;
  categoryName: string;
  categoryCodeRange: string;
  isCategoryCodeRangeExcluded: boolean;
}

const names = {
  internalCategory: ItemName.of([Locale.ja, '内部種類'], [Locale.en, 'Internal Category']),
  categoryMstCode: ItemName.of([Locale.ja, '種類'], [Locale.en, 'Category']),
  categoryMstName: ItemName.of([Locale.ja, '種類名称'], [Locale.en, 'Category Name']),
  categoryMstCodeRange: ItemName.of([Locale.ja, '種類範囲']),
  category: ItemName.of([Locale.ja, '種類']),
  categoryName: ItemName.of([Locale.ja, '種類名称']),
  depreciationAssetClass: ItemName.of([Locale.ja, '償却資産区分']),
  categoryCodeRange: ItemName.of([Locale.ja, '種類範囲']),
} satisfies ItemNames<Schema>;

const categoryMst = {
  names,
  attributes,
};

interface CategoryMst {
  schema: Schema;
  record: Record;
}

export { categoryMst };
export type { CategoryMst };
